import barba from '@barba/core'
const commonFunction = require('./common.js')

import { nav, cart_status } from './../vue'

let initialLoad = true
barba.hooks.beforeEnter(({next}) => {

	// Load Nav Vue Instance
	nav()

	// Load CartStatus Vue Instance
	cart_status()

	commonFunction(next.container)

})
barba.hooks.afterEnter(({next}) => {
	console.log('afterEnter')
	// scroll to top
	window.scrollTo(0, 0)
	if (initialLoad) {
		console.log('initial load')
		document.getElementById('preload-overlay').classList.add('hide')
		initialLoad = false
		return
	}

})


// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
